import {  useHistory } from 'react-router-dom';

export const setIsFetching = (state, defaultData) => {
  const result = {
    ...state,
    isFetching: true,
  };

  if (defaultData !== undefined) {
    result['data'] = defaultData;
  }

  return result;
};

export const resetResponseDataObject = (state, error) => {
  const result = {
    ...state,
    isFetching: false,
    data: {},
    errorMessage: error
  };

  return result;
};

export const resetResponseDataArrays = (state, error) => {
  const result = {
    ...state,
    isFetching: false,
    data: [],
    errorMessage: error
  };

  return result;
};

export const filterResponseData = (state, data) => {
  const result = {
    ...state,
    isFetching: false,
    data: data,
    errorMessage: null
  };

  return result;
};

export const setErrorResponseData = (state, error) => {
  const result = {
    ...state,
    data: [],
    isFetching: false,
    errorMessage: error
  };

  return result;
};

export const transformDisplayName = (item, type) => {
  let result = item;

  if (item && type) {
    if (type === 'YEAR') {
      result = `พศ. ${item}`
    } else if (type === 'ACCOUNT_TYPE') {
      result = item.toUpperCase() === 'O'
        ? 'OMNIBUS'
        : item.toUpperCase() === 'S'
          ? 'SELLING AGENT'
          : item
    }
  }

  return result;
}

export const baseSort = (item1, item2, sortType) => {
	switch (sortType) {
		case 'a':
			if (item1 < item2) {
				return -1;
			} else if (item2 < item1) {
				return 1;
			} else {
				return 0;
			}
		case 'd':
			if (item1 > item2) {
				return -1;
			} else if (item2 > item1) {
				return 1;
			} else {
				return 0;
			}

		default:
			return 0;
	}
}

export const groupItemsByAttr = (items, groupBy) => {
  if (!items || !items.length) return {};

  return items.reduce((prev, target) => {
    if (!prev.hasOwnProperty(target[groupBy])) {
      prev[target[groupBy]] = [target];
    } else {
      prev[target[groupBy]].push(target);
    }
    return prev;
  }, {});
}

export const getScrollPosition = (element) => {
  if (typeof window === `undefined`) return { x: 0, y: 0 };

  const target = element ?? document.querySelector('div#root > .cns-wrapper');
  const position = target.getBoundingClientRect();

  return { x: target.scrollLeft ?? position.left, y: target.scrollTop ?? position.top };
}

export const setScrollPosition = (value, scrollType, element) => {
  if (typeof window !== `undefined`) {
    const target = element ?? document.querySelector('div#root > .cns-wrapper');
    target.scrollTo(scrollType === 'x' ? {left: value, behavior: 'smooth'} : {top: value, behavior: 'smooth'});
  }
}

export const switchOrderNumberRegEx = /\d+[BS]/;
export const onlyNumberRegEx = /[^0-9.]/g;

export const useOpenWebView = () => {
  const history = useHistory()
  return (url) => {
    if(!url) return
    history.push(`/main/web_view?url=${encodeURIComponent(url)}`)
  }
}